// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Depository account categories'" ></sub-header>

  <table class="table">
    <thead>
    <tr>
      <th>No</th>
      <th>Name</th>
      <th>Code</th>
    </tr>
    </thead>
    <tbody>
    <tr ng-repeat="category in \$ctrl.categoryView">
      <td>{{\$index + 1}}</td>
      <td>
        <span ng-style="{'padding-left': 'calc(1rem * ({{category.depth}} - 1))'}"></span>
        {{category.name}}
      </td>
      <td>
        {{category.code}}
      </td>
    </tr>
    </tbody>
  </table>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/depository-account/category-list/depository-account-category-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;